const appName = 'beelineApp';

export const localStorageGetItem  = ( key ) => {

    let item = window.localStorage.getItem( appName );

    if ( item ) {
        return JSON.parse(item)[key];
    }

    return false;

};

export const localStorageSetItem  = ( key, value ) => {

    let item = window.localStorage.getItem( appName );

    if ( !item ) {
        window.localStorage.setItem( appName, '{}' );
        item = window.localStorage.getItem( appName );
    }

    let newStore = JSON.parse( item );

    newStore[key] = value;

    window.localStorage.setItem( appName, JSON.stringify( newStore ) );

    return true;

};

export const localStorageRemoveItem  = ( key ) => {

    let item = window.localStorage.getItem( appName );

    if ( item ) {
        return localStorageSetItem( key, undefined );
    }

    return false;

};